import ComingSoon from "@/features/error/pages/ComingSoon";

function AiChatbot() {
    return <ComingSoon />;
}

export default AiChatbot;
